/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Common filter properties for delivery note bundles
 */
export enum DeliveryNoteBundlesFilterProperties {
  Name = 'name',
  BundleNumber = 'bundleNumber',
  Status = 'status',
  ConsignorName = 'consignorName',
  CarrierName = 'carrierName',
  ConsigneeName = 'consigneeName',
  Discrepancies = 'discrepancies',
  PalletTickets = 'palletTickets',
  DateClosed = 'dateClosed',
  DateCreated = 'dateCreated',
  CheckoutDate = 'checkoutDate'
}
